import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'

export default class LessonRequest extends BaseModelRequest {

  getModelName () {
    return 'lesson'
  }

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  getDetailLesson (id) {
    let url = this.getModelName() + '/detail/' + id
    return this.get(url)
  }

}



// WEBPACK FOOTER //
// ./src/request/LessonRequest.js